export default "__VITE_ASSET__BC9r4fVT__"